module.exports = __webpack_public_path__ + "static/media/Yannick - ZFE 57 - 3ème.665e63e8.mp3";